module.exports = __webpack_public_path__ + "7785724ca01571644800798ecad7cd10.svg";